import PhotoModalViewController from "./photo-modal-view-controller";
import { PHOTO_MODAL_SCREEN_NAMES } from "../utils/constants";

class PulseConsultationPhotoModalViewController extends PhotoModalViewController {
  preprocessScreenData() {
    if (this.screen.identifier !== PHOTO_MODAL_SCREEN_NAMES.pulseRavCase) {
      this.screen.fields = this.screen.fields.map(field => {
        const duplicateField = { ...field };

        if (duplicateField.type === "formTextField") {
          duplicateField.placeholder ||=
            this.appData.settings.translations.max_250_characters;
        }

        return duplicateField;
      });
    }
  }
}

export default PulseConsultationPhotoModalViewController;
